import _isString from 'lodash/isString';
import _isNil from 'lodash/isNil';

import { DataSourceType, TableModuleColumnConfig } from '../../../util/types';
import {
  PropertyConfig,
  getPropertyConfigSet,
  ParseConfiguration,
  PropertyConfigKeyMap,
  resourceAgnosticPropertyKeys,
} from '../../utils/FhirResourceDisplayPropertyConfig/propertyConfig';
import { ConfiguredMomentFormat } from '../../../util/momentFormats';

export default function (
  dataSource: DataSourceType,
  moduleConfigColumns?: TableModuleColumnConfig[],
  momentFormat?: ConfiguredMomentFormat,
): PropertyConfig[] {
  if (!dataSource || !moduleConfigColumns) return [];

  const resourceTypeColumns = getPropertyConfigSet(
    dataSource,
    new ParseConfiguration(momentFormat),
  );
  const columnKeyMap = new PropertyConfigKeyMap(resourceTypeColumns);

  // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
  return moduleConfigColumns
    .filter((column = {} as TableModuleColumnConfig) => !!column.key)
    .map(configuredColumn => {
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      let column: PropertyConfig = null;

      if (configuredColumn.key === resourceAgnosticPropertyKeys.jmesColumn) {
        column = PropertyConfig.initJMESParseColumn(
          // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
          configuredColumn.jmesPath,
          configuredColumn.jmesResultParser,
        );
      } else if (
        !_isNil(configuredColumn.key) &&
        _isString(configuredColumn.key)
      ) {
        column = columnKeyMap.getPropertyConfig(configuredColumn.key);
      } else {
        return null;
      }

      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      column.configuredLabel = configuredColumn.label;
      return column;
    })
    .filter(Boolean);
}
